import { Selector } from '@ngxs/store';
import { AgentGrid, AgentInfo } from '../agent.model';
import { AgentInformationState, AgentSummaryState } from './agent.state';

export class AgentSelector {
  @Selector([AgentSummaryState])
  static getAgentFilters(state: AgentGrid): Omit<AgentGrid, 'agents'> {
    return {
      searchText: state.searchText,
      paging: state.paging,
      totalRecords: state.totalRecords,
    };
  }

  @Selector([AgentSummaryState])
  static getAgentRows(state: AgentGrid) {
    return state.agents;
  }

  @Selector([AgentInformationState])
  static getAgentInfo(state: AgentInfo) {
    return { agent: state.agent, address: state.address };
  }

  @Selector([AgentInformationState])
  static getAgentTypes(state: AgentInfo) {
    return state.agentTypes;
  }
}
